import React, { useCallback, useEffect, useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { DashBoardTitle } from '../../../Components/Title';
import excelImg from '../../../images/excel.png';
import './SurveyForm.css';
import { Roles } from '../../../constants/Roles';
import { Model } from 'survey-core';
import { marketSurveyJson } from './marketSurveyArr';
import { getTerritories, getState, getStateDistrict, dealerDocumentUpload, getDealerActiveInActiveWithStatus, addSurvey, getProducts, generateSurveyReportFile } from '../../../constants/apiCalls';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import { demonstrationJson } from './demonstrationArr';
import { fieldActArr } from './fieldActArr';
import { farmerMeetingArr } from './farmerMeetingArr';
import Storage from '../../../services/Storage';
import { CerealsCropName, fiberOilSeedsCropName, floriCultureCropName, hortiCultureCropName, oliSeedsCropName, plantationCropName, spiceCropName, tuberCropName, vegetablesCropName } from './cropNameArr';
import { SurveyModal } from '../../../Components/CustomModal';
import { useLocation } from 'react-router-dom';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';
import { Permissions } from '../../../constants/Permissions';
import { useSelector } from 'react-redux';

const SurveyForm = () => {
    let user = Storage.getUserInfoDetail();
    let { permissionArr } = useSelector((state) => state.UserGetReducer);
    let isMobile = false;
    const { search } = useLocation();
    isMobile = new URLSearchParams(search).get('isMobile');

    let marketSurveyArr = marketSurveyJson;
    let demonArr = demonstrationJson;
    let activityArr = fieldActArr;
    let meetingArr = farmerMeetingArr;

    let marketSurvey = new Model(marketSurveyArr);
    let demonstrationSurvey = new Model(demonArr);
    let activitySurvey = new Model(activityArr);
    let meetingSurvey = new Model(meetingArr);

    const [isLoading, setIsloading] = useState(false);
    const [isMdalLoading, setIsModalLoading] = useState(false);
    const [marketSurveyModal, setMarketSurveyModal] = useState(false);
    const [demoModal, setDemoModal] = useState(false);
    const [activityModal, setActivityModal] = useState(false);
    const [meetingModal, setMeetingModal] = useState(false);

    const [dealerData, setDealerData] = useState([])
    const [stateList, setStateList] = useState([]);
    const [territoryList, setTerritoryList] = useState([]);
    const [productList, setProductList] = useState([]);

    const handleSurveyClick = () => {
        localStorage.removeItem('districtArr');
        setMarketSurveyModal(!marketSurveyModal);
    }

    const handleDemonstrationClick = () => {
        localStorage.removeItem('districtArr');
        setDemoModal(!demoModal);
    }

    const handleActivityClick = () => {
        localStorage.removeItem('districtArr');
        setActivityModal(!activityModal)
    }
    const handleMeetingClick = () => {
        localStorage.removeItem('districtArr');
        setMeetingModal(!meetingModal);
    }

    useEffect(() => {
        if (user && user.id) {
            getStateData();
            getTerritoryData();
            getDealerData();
            getProductsDetail();
        }
    }, [])

    const getStateData = () => {

        setIsloading(true);
        getState((res) => {
            const { success, data, error } = res;
            if (success === true) {

                if (data && data.length > 0) {
                    setStateList(data);
                    let stateArr = data.map(item => ({ ...item, value: item.name, text: item.name }))
                    let findDemonStateArr = demonArr.pages[0].elements.filter(item => item.name === 'stateName');
                    let findActivityStateArr = activityArr.pages[0].elements.filter(item => item.name === 'stateName');
                    let findMeetingStateArr = meetingArr.pages[0].elements.filter(item => item.name === 'stateName');
                    if (findDemonStateArr && findDemonStateArr.length > 0) {
                        let choiceArr = findDemonStateArr[0].choices;
                        choiceArr.splice(0, choiceArr.length, ...stateArr);
                    }

                    if (findActivityStateArr && findActivityStateArr.length > 0) {
                        let choiceArr = findActivityStateArr[0].choices;
                        choiceArr.splice(0, choiceArr.length, ...stateArr);
                    }

                    if (findMeetingStateArr && findMeetingStateArr.length > 0) {
                        let choiceArr = findMeetingStateArr[0].choices;
                        choiceArr.splice(0, choiceArr.length, ...stateArr);
                    }
                }
                setIsloading(false);
            } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                setIsloading(false);
            }
            setIsloading(false);
        });
    };

    const getTerritoryData = () => {
        setIsloading(true);
        getTerritories((res) => {
            const { success, data, error } = res;
            if (success === true) {
                if (data && data.length > 0) {
                    setTerritoryList(data);
                    let territoyArr = data.map(item => ({ ...item, value: item.name, text: item.name }))
                    let findTerArr = demonArr.pages[0].elements.filter(item => item.name === 'territoryName');
                    if (findTerArr && findTerArr.length > 0) {
                        let choiceArr = findTerArr[0].choices;
                        choiceArr.splice(0, choiceArr.length, ...territoyArr);
                    }
                }
                setIsloading(false);
            } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                setIsloading(false);
            }
            setIsloading(false);
        });
    };

    const getDealerData = () => {
        setIsloading(true);
        let payload = {
            q: '',
            pagesize: 10000000,
            page: 1,
            status: 'active',
            iskycrequire: '',
            is_download: false,
        };
        getDealerActiveInActiveWithStatus((res) => {
            const { data, success, error } = res;
            if (success === true) {
                if (data && data.data && data.data.length > 0) {
                    setDealerData(data.data);

                    let dealerArr = data.data.map(item => ({ ...item, value: item.business_name, text: item.business_name }));

                    let findMarketDealerArr = marketSurveyArr.pages[0].elements.filter(item => item.name === 'selectDealer');
                    let findActivityDealerArr = activityArr.pages[0].elements.filter(item => item.name === 'selectDealer');
                    let findMeetingDealerArr = meetingArr.pages[0].elements.filter(item => item.name === 'selectDealer');

                    if (findMarketDealerArr && findMarketDealerArr.length > 0) {
                        let choiceArr = findMarketDealerArr[0].choices;
                        choiceArr.splice(0, choiceArr.length, ...dealerArr);
                    }

                    if (findActivityDealerArr && findActivityDealerArr.length > 0) {
                        let choiceArr = findActivityDealerArr[0].choices;
                        choiceArr.splice(0, choiceArr.length, ...dealerArr);
                    }

                    if (findMeetingDealerArr && findMeetingDealerArr.length > 0) {
                        let choiceArr = findMeetingDealerArr[0].choices;
                        choiceArr.splice(0, choiceArr.length, ...dealerArr);
                    }
                }
                setIsloading(false);
            } else if (success === false || success === 'undefined') {
                setIsloading(false);
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
            }
            setIsloading(false);
        }, payload);
    };

    const getProductsDetail = () => {
        let payload = {
            q: '',
            page: 1,
            pagesize: 10000000,
            status: 'active',
            is_export: false,
        }
        getProducts((res) => {
            const { data, success, error } = res;
            if (success === true) {
                if (data && data.length > 0) {
                    setProductList(data);
                    let productArr = data.map(item => ({ ...item, value: item.name, text: item.name }));
                    let findProductArr = demonArr.pages[0].elements.filter(item => item.name === 'productName');
                    if (findProductArr && findProductArr.length > 0) {
                        let choiceArr = findProductArr[0].choices;
                        choiceArr.splice(0, choiceArr.length, ...productArr);
                    }
                }
                setIsloading(false);
            } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                setIsloading(false);
            }
            setIsloading(false);
        }, payload);
    }

    demonstrationSurvey
        .onValueChanged
        .add(function (sender, options) {
            let { name, value } = options;
            if (name === "stateName") {
                getDistrictArr(sender, value);
            }
        })

    activitySurvey.onValueChanged
        .add(function (sender, options) {
            let { name, value } = options;
            if (name === "stateName") {
                getDistrictArr(sender, value);
            } else if (name === "cropType") {
                getCropNameArr(sender, value);
            }
        });

    meetingSurvey.onValueChanged
        .add(function (sender, options) {
            let { name, value } = options;
            if (name === "stateName") {
                getDistrictArr(sender, value);
            } else if (name === "cropType") {
                getCropNameArr(sender, value);
            }
        });
    // convert base 64 to bianry
    function dataURLtoFile(dataurl, filename) {

        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    const getDistrictArr = (sender, value) => {
        let districtQues = sender.getQuestionByName('districtName');
        if (value) {   // if (typeof value !== "undefined")
            let filterStateUuid = stateList && stateList.length > 0 ? stateList.filter(item => item.name === value)[0].state_id : '';
            if (filterStateUuid !== '') {
                let payload = {
                    state_id: filterStateUuid
                }
                // setIsModalLoading(true);
                getStateDistrict((res) => {
                    const { success, data, error } = res;
                    if (success === true && data && data.length > 0) {
                        // setDistrictData(data);
                        let districtArr = data.map(item => ({ ...item, value: item.name, text: item.name }));
                        localStorage.setItem('districtArr', JSON.stringify(districtArr));
                        districtQues.choices = districtArr;
                        // setIsModalLoading(false);
                    } else if (success === false || success === 'undefined') {
                        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                        // setIsModalLoading(false);
                    }
                    // setIsModalLoading(false);
                }, payload);
            }

        } else {
            districtQues.choices = [];
        }
        districtQues.value = null;
    }

    const getCropNameArr = (sender, value) => {
        let cropNameQues = sender.getQuestionByName('cropName');
        if (value) {   // if (typeof value !== "undefined")
            if (value === 'Cereals') {
                cropNameQues.choices = CerealsCropName;
            } else if (value === 'Oilseeds') {
                cropNameQues.choices = oliSeedsCropName;
            } else if (value === 'Fibre And Oilseed') {
                cropNameQues.choices = fiberOilSeedsCropName;
            } else if (value === 'Tuber Crops') {
                cropNameQues.choices = tuberCropName;
            } else if (value === 'Spice Crops') {
                cropNameQues.choices = spiceCropName;
            } else if (value === 'Vegetables') {
                cropNameQues.choices = vegetablesCropName;
            } else if (value === 'Floriculture') {
                cropNameQues.choices = floriCultureCropName;
            } else if (value === 'Horticulture') {
                cropNameQues.choices = hortiCultureCropName;
            } else if (value === 'Plantation') {
                cropNameQues.choices = plantationCropName;
            }

        } else {
            cropNameQues.choices = [];
        }
        cropNameQues.value = null;
    }

    marketSurvey.onComplete.add(useCallback((sender) => {
        let results = sender.data;
        let dealerId = dealerData && dealerData.length > 0 ? dealerData.filter(item => item.business_name === results.selectDealer)[0].id : '';
        let territoryName = dealerData && dealerData.length > 0 ? dealerData.filter(item => item.business_name === results.selectDealer)[0].territory : ''
        if (dealerId && territoryName) {
            let payload = {
                survey: [{
                    selectDealer: results.selectDealer,
                    selectDealerId: dealerId,
                    territoryName: territoryName,
                    surveyFor: results.surveyFor,
                    selectFormType: results.selectFormType,
                    companyName: results.companyName,
                    brandName: results.brandName,
                    technicalName: results.technicalName,
                    marketSize: results.marketSize,
                    directDealerPrice: results.directDealerPrice,
                    farmerPrice: results.farmerPrice,
                    mrpEnter: results.mrpEnter,
                    schemaDetails: results.schemaDetails || '',
                    availablePackages: results.availablePackages,
                    dosePerAcre: results.dosePerAcre,
                    quantitySold: results.quantitySold

                }],
                survey_type: "market_survey"
            }

            setIsModalLoading(true);
            addSurvey((res) => {
                const { success, message, error } = res;
                if (success === true) {
                    ModalService.openAlert('', message, 'success');
                    setMarketSurveyModal(!marketSurveyModal);
                    setIsModalLoading(false);
                } else if (success === false || success === 'undefined') {
                    ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                    setIsModalLoading(false);
                }
                setIsModalLoading(false);
            }, payload);
        }
    }, [dealerData, marketSurveyModal]));

    demonstrationSurvey.onComplete.add(useCallback(async (sender) => {
        let results = sender.data;
        let districtList = JSON.parse(localStorage.getItem('districtArr'));

        let stateId = stateList && stateList.length > 0 ? stateList.filter(item => item.name === results.stateName)[0].id : '';
        let districtId = districtList && districtList.length > 0 ? districtList.filter(item => item.name === results.districtName)[0].id : '';
        let territoryId = territoryList && territoryList.length > 0 ? territoryList.filter(item => item.name === results.territoryName)[0].id : '';

        let productId = productList && productList.length > 0 ? productList.filter(item => item.name === results.productName)[0].id : '';

        let imgArr = [];

        for (let i = 0; i < results.uploadPhoto.length; i++) {
            let formData = new FormData();
            // let imgBase64 = results.uploadPhoto[i].content;
            // let imgName = results.uploadPhoto[i].name;
            // let imgFileBinary = dataURLtoFile(imgBase64, imgName);
            // formData.append('files', imgFileBinary);
            // formData.append('ownerimage', true);

            if (isMobile === 'true') {
                let base64URL = results.uploadPhoto[i].content;
                formData.append('files', base64URL);
                formData.append('isBase64', true);
                formData.append('ownerimage', true);

            } else {
                let imgBase64 = results.uploadPhoto[i].content;
                let imgName = results.uploadPhoto[i].name;
                let imgFileBinary = dataURLtoFile(imgBase64, imgName);
                formData.append('files', imgFileBinary);
                formData.append('ownerimage', true);
            }

            setIsModalLoading(true);
            // dealerDocumentUpload((res) => {
            //     const { success, data, message, error } = res;
            //     if (success === true) {
            //         imgArr.push(data.imageUrl);
            //         setIsModalLoading(true);


            //         ModalService.openAlert('', message, 'success');
            //         setIsModalLoading(false);
            //     } else if (success === false || success === 'undefined') {
            //         ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
            //         setIsModalLoading(false);
            //     }
            // }, formData);
            setIsModalLoading(true);

            const uploadResult = await new Promise((resolve, reject) => {
                dealerDocumentUpload((res) => {
                    resolve(res);
                }, formData);
            });

            const { success, data, error } = uploadResult;

            if (success === true) {
                imgArr.push(data.imageUrl);
                setIsModalLoading(true);
                // ModalService.openAlert('', message, 'success');
                setIsModalLoading(false);
            } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                setIsModalLoading(false);
            }
        }

        if (imgArr && imgArr.length === results.uploadPhoto.length && stateId && districtId && territoryId & productId) {
            let payload = {
                survey: [{
                    farmerName: results.farmerName,
                    contactNumber: results.contactNumber['+91'],
                    villageName: results.villageName,
                    stateName: results.stateName,
                    stateId: stateId,
                    districtName: results.districtName,
                    districtId: districtId,
                    territoryName: results.territoryName,
                    territoryId: territoryId,
                    productName: results.productName,
                    productId: productId,
                    stageApplication: results.stageApplication,
                    uploadPhoto: imgArr,
                    feedBackName: results.feedBackName

                }],
                survey_type: "demonstration"
            }

            setIsModalLoading(true);
            addSurvey((res) => {
                const { success, message, error } = res;
                if (success === true) {
                    ModalService.openAlert('', message, 'success');
                    setDemoModal(!demoModal);
                    setIsModalLoading(false);
                } else if (success === false || success === 'undefined') {
                    ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                    setIsModalLoading(false);
                }
                setIsModalLoading(false);
            }, payload);
        }
    }, [stateList, territoryList, productList, demoModal]));

    activitySurvey.onComplete.add(useCallback(async (sender) => {
        let results = sender.data;
        let districtList = JSON.parse(localStorage.getItem('districtArr'));
        let dealerId = dealerData && dealerData.length > 0 ? dealerData.filter(item => item.business_name === results.selectDealer)[0].id : '';
        let stateId = stateList && stateList.length > 0 ? stateList.filter(item => item.name === results.stateName)[0].id : '';
        let districtId = districtList && districtList.length > 0 ? districtList.filter(item => item.name === results.districtName)[0].id : '';

        let imgArr = [];

        for (let i = 0; i < results.fieldDayImage.length; i++) {
            let formData = new FormData();
            // let imgBase64 = results.fieldDayImage[i].content;
            // let imgName = results.fieldDayImage[i].name;
            // let imgFileBinary = dataURLtoFile(imgBase64, imgName);
            // formData.append('files', imgFileBinary);
            // formData.append('ownerimage', true);

            if (isMobile === 'true') {
                let base64URL = results.fieldDayImage[i].content;
                formData.append('files', base64URL);
                formData.append('isBase64', true);
                formData.append('ownerimage', true);

            } else {
                let imgBase64 = results.fieldDayImage[i].content;
                let imgName = results.fieldDayImage[i].name;
                let imgFileBinary = dataURLtoFile(imgBase64, imgName);
                formData.append('files', imgFileBinary);
                formData.append('ownerimage', true);
            }

            setIsModalLoading(true);

            const uploadResult = await new Promise((resolve, reject) => {
                dealerDocumentUpload((res) => {
                    resolve(res);
                }, formData);
            });

            const { success, data, error } = uploadResult;

            if (success === true) {
                imgArr.push(data.imageUrl);
                setIsModalLoading(true);
                // ModalService.openAlert('', message, 'success');
                setIsModalLoading(false);
            } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                setIsModalLoading(false);
            }
        }
        if (imgArr && imgArr.length === results.fieldDayImage.length && stateId && districtId && dealerId) {
            let payload = {
                survey: [{
                    selectDealer: results.selectDealer,
                    selectDealerId: dealerId,
                    cropType: results.cropType,
                    cropName: results.cropName,
                    fieldDayDate: results.fieldDayDate,
                    numberOfFarmersPresent: results.numberOfFarmersPresent,
                    villageName: results.villageName,
                    stateName: results.stateName,
                    stateId: stateId,
                    districtName: results.districtName,
                    districtId: districtId,
                    meetingLocation: results.meetingLocation,
                    fieldDayImage: imgArr,
                }],
                survey_type: "field_activity"
            }

            setIsModalLoading(true);
            addSurvey((res) => {
                const { success, message, error } = res;
                if (success === true) {
                    ModalService.openAlert('', message, 'success');
                    setActivityModal(!activityModal);
                    setIsModalLoading(false);
                } else if (success === false || success === 'undefined') {
                    ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                    setIsModalLoading(false);
                }
                setIsModalLoading(false);
            }, payload);
        }
    }, [dealerData, stateList, activityModal]));

    meetingSurvey.onComplete.add(useCallback(async (sender) => {
        let results = sender.data;
        let districtList = JSON.parse(localStorage.getItem('districtArr'));
        let dealerId = dealerData && dealerData.length > 0 ? dealerData.filter(item => item.business_name === results.selectDealer)[0].id : '';
        let stateId = stateList && stateList.length > 0 ? stateList.filter(item => item.name === results.stateName)[0].id : '';
        let districtId = districtList && districtList.length > 0 ? districtList.filter(item => item.name === results.districtName)[0].id : '';

        let imgArr = [];

        for (let i = 0; i < results.meetingImage.length; i++) {
            let formData = new FormData();
            if (isMobile === 'true') {
                let base64URL = results.meetingImage[i].content;
                formData.append('files', base64URL);
                formData.append('isBase64', true);
                formData.append('ownerimage', true);

            } else {
                let imgBase64 = results.meetingImage[i].content;
                let imgName = results.meetingImage[i].name;
                let imgFileBinary = dataURLtoFile(imgBase64, imgName);
                formData.append('files', imgFileBinary);
                formData.append('ownerimage', true);
            }


            setIsModalLoading(true);

            const uploadResult = await new Promise((resolve, reject) => {
                dealerDocumentUpload((res) => {
                    resolve(res);
                }, formData);
            });

            const { success, data, error } = uploadResult;

            if (success === true) {
                imgArr.push(data.imageUrl);
                setIsModalLoading(true);
                // ModalService.openAlert('', message, 'success');
                setIsModalLoading(false);
            } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                setIsModalLoading(false);
            }

        }

        if (imgArr && imgArr.length === results.meetingImage.length && stateId && districtId && dealerId) {
            let payload = {
                survey: [{
                    selectDealer: results.selectDealer,
                    selectDealerId: dealerId,
                    meetingDate: results.meetingDate,
                    cropType: results.cropType,
                    cropName: results.cropName,
                    numberOfFarmersPresent: results.numberOfFarmersPresent,
                    villageName: results.villageName,
                    stateName: results.stateName,
                    stateId: stateId,
                    districtName: results.districtName,
                    districtId: districtId,
                    meetingLocation: results.meetingLocation,
                    meetingImage: imgArr,
                }],
                survey_type: "farmer_meeting"
            }

            setIsModalLoading(true);
            addSurvey((res) => {
                const { success, message, error } = res;
                if (success === true) {
                    ModalService.openAlert('', message, 'success');
                    setMeetingModal(!meetingModal);
                    setIsModalLoading(false);
                } else if (success === false || success === 'undefined') {
                    ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                    setIsModalLoading(false);
                }
                setIsModalLoading(false);
            }, payload);
        }

    }, [dealerData, stateList, meetingModal]));

    // Report Generate

    const generateReport = (surveyType) => {
        let payload = {
            survey_form_type: surveyType
        }
        setIsloading(true);
        generateSurveyReportFile((res) => {
            const { data, success, error } = res;
            if (success === true) {
                window.open(data.file, '_blank');
                setIsloading(false);
            } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                setIsloading(false);
            }
            setIsloading(false);
        }, payload);
    }

    return (
        <>
            {(isMobile === 'false' || isMobile === null) ? <AppHeader /> : ''}
            <div className='app-main' style={{ paddingTop: `${(isMobile === 'false' || isMobile === null) ? '60px' : '0px'}` }}>
                {(isMobile === 'false' || isMobile === null) ? <AppSidebar /> : ''}
                <div className='app-main__outer'>
                    <div className='app-main__inner rms-wrapper'>
                        <div id='surveyForm'>
                            {isLoading && <CustomSpinner />}
                            <div className='pageWrapper'>
                                <Container fluid>
                                    {isMobile === 'false' ? (
                                        <Row>
                                            <Col xs={12}>
                                                <div className='pageheader'>
                                                    <DashBoardTitle dashBorardName="Survey and Forms" />
                                                </div>
                                            </Col>
                                        </Row>
                                    ) : ''}
                                    <div className='cardWrapper'>
                                        <Row>
                                            <Col xl={4} lg={3} md={6}>
                                                <div className='cardBlock'>
                                                    <div className='mainTitle m-0'>Market Survey</div>
                                                    <div className='cardBlockWrapper'>
                                                        {console.log('user', user)}
                                                        <Row>
                                                            {user &&
                                                                // (user.role === Roles.TM_NAME || user.role === Roles.SH_NAME || user.role === Roles.TCO_NAME)
                                                                permissionArr && permissionArr.length > 0 &&
                                                                permissionArr.includes(Permissions.CRETAE_SURVEY)
                                                                ?
                                                                <Col>
                                                                    <div className='cardLink'>
                                                                        <p className='linkText mb-0' onClick={handleSurveyClick}>New Survey</p>
                                                                    </div>
                                                                </Col>
                                                                : ''}
                                                            <Col>
                                                                <div className='cardLink'>
                                                                    <div className='reportCard' onClick={() => generateReport('market_survey')}>
                                                                        <p className='linkText mb-0'>Download Report</p>
                                                                        <img src={excelImg} width={18} height={18} alt='excelIcon' className='ml-1' />
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Col>
                                            {/* <Col xl={4} lg={3} md={6}>
                                                <div className='cardBlock'>
                                                    <div className='mainTitle m-0'>Demonstration</div>
                                                    <div className='cardBlockWrapper'>
                                                        <Row>
                                                            {user &&
                                                                permissionArr && permissionArr.length > 0 &&
                                                                permissionArr.includes(Permissions.CRETAE_SURVEY)
                                                                ?
                                                                <Col>
                                                                    <div className='cardLink'>
                                                                        <p className='linkText mb-0' onClick={handleDemonstrationClick}>New Demonstration</p>
                                                                    </div>
                                                                </Col>
                                                                : ''}
                                                            <Col>
                                                                <div className='cardLink'>
                                                                    <div className='reportCard' onClick={() => generateReport('demonstration')}>
                                                                        <p className='linkText mb-0'>Download Report</p>
                                                                        <img src={excelImg} width={18} height={18} alt='excelIcon' className='ml-1' />
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xl={4} lg={3} md={6}>
                                                <div className='cardBlock'>
                                                    <div className='mainTitle m-0'>field Activity</div>
                                                    <div className='cardBlockWrapper'>
                                                        <Row>
                                                            {user &&
                                                                permissionArr && permissionArr.length > 0 &&
                                                                permissionArr.includes(Permissions.CRETAE_SURVEY)
                                                                ?
                                                                <Col>
                                                                    <div className='cardLink'>
                                                                        <p className='linkText mb-0' onClick={handleActivityClick}>New Activity</p>
                                                                    </div>
                                                                </Col>
                                                                : ''}
                                                            <Col>
                                                                <div className='cardLink'>
                                                                    <div className='reportCard' onClick={() => generateReport('field_activity')}>
                                                                        <p className='linkText mb-0'>Download Report</p>
                                                                        <img src={excelImg} width={18} height={18} alt='excelIcon' className='ml-1' />
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xl={4} lg={3} md={6}>
                                                <div className='cardBlock'>
                                                    <div className='mainTitle m-0'>Farmer Meeting</div>
                                                    <div className='cardBlockWrapper'>
                                                        <Row>
                                                            {user &&
                                                                permissionArr && permissionArr.length > 0 &&
                                                                permissionArr.includes(Permissions.CRETAE_SURVEY)
                                                                ?
                                                                <Col>
                                                                    <div className='cardLink'>
                                                                        <p className='linkText mb-0' onClick={handleMeetingClick}>New Meeting</p>
                                                                    </div>
                                                                </Col>
                                                                : ''}
                                                            <Col>
                                                                <div className='cardLink'>
                                                                    <div className='reportCard' onClick={() => generateReport('farmer_meeting')}>
                                                                        <p className='linkText mb-0'>Download Report</p>
                                                                        <img src={excelImg} width={18} height={18} alt='excelIcon' className='ml-1' />
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Col> */}
                                        </Row>
                                    </div>
                                </Container>
                            </div>

                            {/* Market Survey Modal */}
                            <SurveyModal
                                isOpen={marketSurveyModal}
                                toggle={() => setMarketSurveyModal(!marketSurveyModal)}
                                modalTitle='Market Survey'
                                modalData={marketSurvey}
                                isMdalLoading={isMdalLoading}
                            />

                            {/* Demonstration Modal */}
                            <SurveyModal
                                isOpen={demoModal}
                                toggle={() => setDemoModal(!demoModal)}
                                modalTitle='Demonstration'
                                modalData={demonstrationSurvey}
                                isMdalLoading={isMdalLoading}
                            />

                            {/* Activity Modal */}
                            <SurveyModal
                                isOpen={activityModal}
                                toggle={() => setActivityModal(!activityModal)}
                                modalTitle='Field Activity'
                                modalData={activitySurvey}
                                isMdalLoading={isMdalLoading}
                            />

                            {/* Meeting Modal */}
                            <SurveyModal
                                isOpen={meetingModal}
                                toggle={() => setMeetingModal(!meetingModal)}
                                modalTitle='Farmer Meeting'
                                modalData={meetingSurvey}
                                isMdalLoading={isMdalLoading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SurveyForm;
